import React from 'react';
import { HeaderText2TW } from '../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/pro-regular-svg-icons';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

export const ListTitle: React.FC<{ onAddEventClick: React.MouseEventHandler<HTMLElement> }> = ({ onAddEventClick }) => {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      })}
    >
      <HeaderText2TW className={css({ fontWeight: '500' })}>Events</HeaderText2TW>
      <Button tone={'brand'} emphasis={'filled'} size="sm" onClick={onAddEventClick}>
        <FontAwesomeIcon className={'pr-2'} icon={faCalendarPlus} />
        Add Event
      </Button>
    </div>
  );
};
